import { render, staticRenderFns } from "./SubmitInProgress.vue?vue&type=template&id=59c04b10&scoped=true&"
import script from "./SubmitInProgress.vue?vue&type=script&lang=js&"
export * from "./SubmitInProgress.vue?vue&type=script&lang=js&"
import style0 from "./SubmitInProgress.vue?vue&type=style&index=0&id=59c04b10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c04b10",
  null
  
)

export default component.exports